import { request } from "utils/request"
import { asyncAction } from "./common"

const initialState = {
  hasFetched: false,
  seatsPurchased: null,
  seatsTotal: null,
  membersPlanners: null,
  viewOnly: null,
}

export function reducer(state = initialState, action) {
  switch (action.type) {
    case "seatInfo/fetch/BEGIN":
      return { ...state, hasFetched: true }
    case "seatInfo/fetch":
      return {
        ...state,
        seatsPurchased: action.res.seatsPurchased,
        seatsTotal: action.res.seatsTotal,
        membersPlanners: action.res.membersPlanners,
        viewOnly: action.res.viewOnly,
      }
    case "auth/logout":
      return initialState
    default:
      return state
  }
}

export const fetch = asyncAction("seatInfo/fetch", (_dispatch) => {
  return request("GET", `/company/seat-info`)
})
